import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SliderInput from '../../../components/SliderInput/SliderInput';
import Button from '../../../components/Button/Button';
import Tabs from '../../../components/Tabs/Tabs';
import { AVAILABLE_GENERATORS } from '../generate-text';
import Background from '../../../components/Background/Background';
import classes from './Settings.styles.less';
const types = AVAILABLE_GENERATORS.map((generator) => ({
    value: generator,
    label: `${generator.charAt(0).toUpperCase() + generator.slice(1)} ipsum`,
}));
export default function Settings({ onTypeChange, type, length, onLengthChange, onSubmit, copied }) {
    return (_jsxs(Background, { className: classes.wrapper, children: [_jsx(Tabs, { data: types, active: type, onTabChange: onTypeChange }), _jsxs("div", { className: classes.footer, children: [_jsxs("div", { className: classes.length, children: [_jsx("div", { className: classes.label, children: "Amount of paragraphs" }), _jsx(SliderInput, { value: length, min: 1, max: 20, onChange: onLengthChange })] }), _jsx(Button, { className: classes.control, onClick: onSubmit, disabled: copied, theme: copied ? 'success' : 'primary', children: copied ? 'Copied to clipboard' : 'Generate and copy to clipboard' })] })] }));
}
